import useMediaQuery from "../../hooks/useMediaQuery";

const VideoEmbed = ({src, srcMobile}) => {
    const isDesktop = useMediaQuery('(min-width: 1024px)');

    return <video src={isDesktop ? src : srcMobile} playsInline muted autoPlay loop/>;
};

export default VideoEmbed;
